import React from "react";
import { BancoToggleSwitch, ToggleSwitchConfig }
  from "../../../../Common/components/BancoToggleSwitch/BancoToggleSwitch";
import styles from "../styles/styles.module.scss";

export type ConsentToggleProps = {
    heading: string,
    body: string,
    toggleConfig?: ToggleSwitchConfig
}

export const ConsentToggle = ({
  heading,
  body,
  toggleConfig
}: ConsentToggleProps) => {
  return (
    <div className={ styles.toggleContainer }>
      <div className={ styles.toggleContentContainer }>
        <p className={ styles.subheading }>{ heading }</p>
        <p className={ styles.p }>{ body }</p>
      </div>
      {
        toggleConfig &&
        <BancoToggleSwitch
          config={ toggleConfig }
          htmlClass={ styles.toggleSwitch }
        />
      }
    </div>
  );
};
